import { Middleware } from '@nuxt/types';
import api from '~/services/api';

const authMiddleware: Middleware = async (context) => {
  const frontendKey = context.route?.query?.fk;
  if (frontendKey) {
    try {
      const authInfo = await api.loginWithFrontendKey(context, {
        key: frontendKey,
      });
      if (typeof window === 'undefined') {
        // await (context as any).$cookies.remove('auth');
        await (context as any).$cookies.set(
          'auth',
          { token: authInfo.token },
          {
            path: '/',
            maxAge: 60 * 60 * 24 * 7,
            sameSite: true,
          }
        );
      }
      const customer = { anonymous: true, role: 'guest' };
      //TODO: limit company data
      // console.log('GET COMPANY', authInfo);
      const company = await api.getCompany(context, authInfo.token);
      context.store.dispatch('auth/setCompany', company);
      // context.store.dispatch('auth/setCompany', {
      //   hourlyOrdersEnabled: true,
      //   jobConfigList: [],
      //   invoicesRecipient: 'client',
      // });
      context.store.dispatch('auth/setCustomer', customer);
    } catch (e) {
      console.error(e);
      return context.redirect((context as any).localePath(`/error`));
    }
    return;
  }
  let customer: { id: any; role: any; isRegistered: any; countries: string[] },
    company;
  try {
    if (
      typeof window === 'undefined' &&
      (context as any)?.$cookies?.get('auth')?.token
    ) {
      const response = await api.refreshToken(context);
      (context as any).$cookies.set(
        'auth',
        { token: response.token },
        {
          path: '/',
          maxAge: 60 * 60 * 24 * 7 * 4,
          sameSite: true,
        }
      );
    }
    // 401 or general failure
    customer = await api.getCustomer(context);
    company = await api.getCompany(context);
    // console.log('Company', company);
    if (company.memberSettingsList) {
      company.memberSettingsList.forEach(
        (member: { userId: any; role: any; countriesList: string[] }) => {
          if (member.userId === customer.id) {
            customer.role = member.role;
            customer.countries = member.countriesList;
          }
        }
      );
    }
    // console.log(customer);
    context.store.dispatch('auth/setCompany', company);
    context.store.dispatch('auth/setCustomer', customer);
    context.$sentry.setUser({ id: customer.id });
  } catch (e) {
    console.error(e);
    return context.redirect((context as any).localePath(`/login`));
  }
  // token expired or not registered
  if (!customer.isRegistered || !company.name) {
    (context as any).$cookies.remove('auth');
    window.location.href = (context as any).localePath({
      path: `/login?error=unregistered`,
    });
  }
};

export default authMiddleware;
